var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1C3.19 1 2.125 2.065 2.125 3.375C2.125 4.66 3.13 5.7 4.44 5.745C4.48 5.74 4.52 5.74 4.55 5.745C4.56 5.745 4.565 5.745 4.575 5.745C4.58 5.745 4.58 5.745 4.585 5.745C5.865 5.7 6.87 4.66 6.875 3.375C6.875 2.065 5.81 1 4.5 1Z",
    fill: "#364A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03998 7.07445C5.64498 6.14445 3.36998 6.14445 1.96498 7.07445C1.32998 7.49945 0.97998 8.07445 0.97998 8.68945C0.97998 9.30445 1.32998 9.87445 1.95998 10.2945C2.65998 10.7645 3.57998 10.9995 4.49998 10.9995C5.41998 10.9995 6.33998 10.7645 7.03998 10.2945C7.66998 9.86945 8.01998 9.29945 8.01998 8.67945C8.01498 8.06445 7.66998 7.49445 7.03998 7.07445Z",
    fill: "#364A5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99518 3.66907C10.0752 4.63907 9.38518 5.48907 8.43018 5.60407C8.42518 5.60407 8.42518 5.60407 8.42018 5.60407H8.40518C8.37518 5.60407 8.34518 5.60407 8.32018 5.61407C7.83518 5.63907 7.39018 5.48407 7.05518 5.19907C7.57018 4.73907 7.86518 4.04907 7.80518 3.29907C7.77018 2.89407 7.63018 2.52407 7.42018 2.20907C7.61018 2.11407 7.83018 2.05407 8.05518 2.03407C9.03518 1.94907 9.91018 2.67907 9.99518 3.66907Z",
    fill: "#364A5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9949 8.2952C10.9549 8.7802 10.6449 9.2002 10.1249 9.4852C9.62487 9.7602 8.99487 9.8902 8.36987 9.8752C8.72987 9.5502 8.93987 9.1452 8.97987 8.7152C9.02987 8.0952 8.73487 7.5002 8.14487 7.0252C7.80987 6.7602 7.41987 6.5502 6.99487 6.3952C8.09987 6.0752 9.48987 6.2902 10.3449 6.9802C10.8049 7.3502 11.0399 7.8152 10.9949 8.2952Z",
    fill: "#364A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherIcon);
export default __webpack_public_path__ + "static/media/teacherIcon.fa164a4088ac28c4b4b78bee57a052c7.svg";
export { ForwardRef as ReactComponent };